import type * as api from '@gitbook/api-client';
import { confirm, toast } from '@gitbook/spine-react';
import { useEventCallback } from '@gitbook/util-react-hooks';

import { apiClient } from '../../../state';

export interface UseSetSiteVariantVisibilityProps {
    organization: api.Organization;
    site: api.Site;
}

export function useSetSiteVariantVisibility(props: UseSetSiteVariantVisibilityProps) {
    const { site, organization } = props;
    return useEventCallback((siteSpace: api.SiteSpace) => {
        void confirm({
            title: 'Toggle variant visibility in site navigation',
            description: `Hidden variants do not appear in the site navigation, but are still accessible via direct links and URLs.`,
            confirmLabel: siteSpace.hidden ? 'Show variant' : 'Hide variant',
            onConfirm: async (_event, { preventClose }) => {
                await toast.catch(
                    async () => {
                        await apiClient.siteSpaces.updateSiteSpaceById(
                            organization.id,
                            site.id,
                            siteSpace.id,
                            {
                                hidden: !siteSpace.hidden,
                            }
                        );

                        toast.success(
                            siteSpace.hidden
                                ? 'Variant is now visible in site navigation'
                                : 'Variant is now hidden from site navigation'
                        );
                    },
                    'Error while updating variant visibility',
                    { onReject: preventClose }
                );
            },
        });
    });
}
